import applications from "./applications";
import limitations from "./limitations";

export default {
    applications,
    limitations,
};
